import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/api/client";
import { AuthCard } from "@/components/auth/AuthCard";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (!token) {
      setError("Reset token is missing");
      return;
    }
    setIsLoading(true);
    try {
      await api.resetPassword(token, newPassword);
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Reset failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthCard
      title="EVzone Media & Content Platform"
      subtitle="Choose a new password"
      footer={success ? <Link to="/auth/login">Sign in with your new password</Link> : <Link to="/auth/login">Back to sign in</Link>}
    >
      {success ? (
        <div className="ev-login__success" role="status">
          Your password has been reset. You can now sign in.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="ev-login__form">
          <label className="ev-login__field">
            <span>New password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              disabled={isLoading}
              required
              minLength={8}
            />
          </label>
          <label className="ev-login__field">
            <span>Confirm password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={isLoading}
              required
              minLength={8}
            />
          </label>
          {error && <div className="ev-login__error" role="alert">{error}</div>}
          <button type="submit" className="ev-login__submit" disabled={isLoading}>
            {isLoading ? "Resetting…" : "Reset password"}
          </button>
        </form>
      )}
    </AuthCard>
  );
}
